import isProd from './isProduction'

export const props = (prod = isProd()) => ({
  cfeApiUrl: prod ? 'https://www.citationmachine.net/api' : '//playground.citationmachine.net/api',
  wptAppUrl: prod ? 'https://writing.citationmachine.net' : '//writing-playground.citationmachine.net',
  wptApiUrl: prod ? 'https://wbe-prod-api.citationmachine.net' : '//writing-backend.playground.citationmachine.net',
  cfeAuth: true,
})

export default function getWidgetProps({
  theme = 'citationmachine',
  headingText = 'Try our smart proofreader',
  subheadingText = `Don't worry, your writing won't be searchable publicly.`,
} = {}) {
  return {
    theme,
    headingText,
    subheadingText,
    ...props(),
  }
}
